import { render, staticRenderFns } from "./OtherForms.vue?vue&type=template&id=5724bf30"
import script from "./OtherForms.vue?vue&type=script&lang=js"
export * from "./OtherForms.vue?vue&type=script&lang=js"
import style0 from "./OtherForms.vue?vue&type=style&index=0&id=5724bf30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports